/**
 * @prettier
 */
const ACTIONS = {
    USER_LOGGED_IN: 'TRAVELER/USER_LOGGED_IN'
};

const ACTION_CREATORS = {
    setUserLoggedIn(publicUuid) {
        if (publicUuid) {
            window.analyticsdatalayer.publicuuid = publicUuid;
        }
        return {
            type: ACTIONS.USER_LOGGED_IN,
            payload: {
                isLoggedIn: true
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
